const fabInfoEditorConfig = {
  initialContent: {
    intro_title: "",
    intro_text: "",
    faq_items: [],
    banner_one_title: "",
    banner_one_image_url: "",
    banner_two_title: "",
    banner_two_image_url: "",
  },

imageFields: {
  bannerOne: {
    contentKey: "banner_one_image_url",
  },

  bannerTwo: {
    contentKey: "banner_two_image_url",
  },
},
  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,

      faq_items: Array.isArray(content.faq_items)
        ? content.faq_items.map((item) => ({
            question: item?.question || "",
            answer_type: item?.answer_type || "text",
            answer_text: item?.answer_text || "",

            answer_lines_text: Array.isArray(item?.answer_lines)
              ? item.answer_lines.join("\n")
              : "",

            answer_items_text: Array.isArray(item?.answer_items)
              ? item.answer_items
                  .map((entry) => {
                    const text = entry?.text || "";
                    const linkLabel = entry?.link_label || "";
                    const linkUrl = entry?.link_url || "";

                    return linkLabel && linkUrl
                      ? `${text} | ${linkLabel} | ${linkUrl}`
                      : text;
                  })
                  .join("\n")
              : "",

            link_label: item?.link_label || "",
            link_url: item?.link_url || "",
          }))
        : [],
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      intro_title: templateState.intro_title?.trim() || "",
      intro_text: templateState.intro_text?.trim() || "",

      faq_items: Array.isArray(templateState.faq_items)
        ? templateState.faq_items
            .map((item) => ({
              question: item?.question?.trim() || "",
              answer_type: item?.answer_type || "text",
              answer_text: item?.answer_text?.trim() || "",

              answer_lines: item?.answer_lines_text
                ? item.answer_lines_text
                    .split("\n")
                    .map((line) => line.trim())
                    .filter(Boolean)
                : [],

              answer_items: item?.answer_items_text
                ? item.answer_items_text
                    .split("\n")
                    .map((line) => line.trim())
                    .filter(Boolean)
                    .map((line) => {
                      const parts = line
                        .split("|")
                        .map((part) => part.trim());

                      if (parts.length >= 3) {
                        return {
                          text: parts[0] || "",
                          link_label: parts[1] || "",
                          link_url: parts[2] || "",
                        };
                      }

                      return {
                        text: line,
                      };
                    })
                : [],

              link_label: item?.link_label?.trim() || "",
              link_url: item?.link_url?.trim() || "",
            }))
            .filter((item) => item.question)
        : [],

      banner_one_title:
        templateState.banner_one_title?.trim() || "",
banner_one_image_url:
  sharedState.resolvedImageUrls?.bannerOne || "",

      banner_two_title:
        templateState.banner_two_title?.trim() || "",
banner_two_image_url:
  sharedState.resolvedImageUrls?.bannerTwo || "",
    };
  },

getStep2Props({
  templateState,
  setTemplateField,
  getImageField,
  setImageFile,
  setImageRemoved,
}) {
  const bannerOne = getImageField("bannerOne");
  const bannerTwo = getImageField("bannerTwo");

  return {
    templateState,
    setTemplateField,

    bannerOneImageFile: bannerOne.file,
    setBannerOneImageFile: (file) =>
      setImageFile("bannerOne", file),
    existingBannerOneImageUrl: bannerOne.existingUrl,
    removeBannerOneImage: bannerOne.remove,
    setRemoveBannerOneImage: (remove) =>
      setImageRemoved("bannerOne", remove),

    bannerTwoImageFile: bannerTwo.file,
    setBannerTwoImageFile: (file) =>
      setImageFile("bannerTwo", file),
    existingBannerTwoImageUrl: bannerTwo.existingUrl,
    removeBannerTwoImage: bannerTwo.remove,
    setRemoveBannerTwoImage: (remove) =>
      setImageRemoved("bannerTwo", remove),
  };
},
};

export default fabInfoEditorConfig;